/**
 * Shared scoring utilities for VEROOGLE Phase 1 cards.  Lives outside
 * any single card so the top-level MetricsBar can compute "hot leads"
 * from the same formula T1020cr uses.
 */
export const SCORING_TODAY = new Date("2026-02-15");

export const scoreLead = (lead, w = { volume: 50, risk: 20, recency: 30 }) => {
  const vAx = Math.min(100, (lead.volume / 250000) * 100);
  const rAx = Math.max(30, 70 - (lead.volume > 200000 ? 10 : 0));
  let recDays = 365;
  if (lead.permit && lead.permit !== "N/A") {
    const d = new Date(lead.permit);
    recDays = Math.max(0, Math.round((SCORING_TODAY - d) / 86400000));
  }
  const recAx = Math.max(0, 100 - recDays / 3);
  const total =
    (w.volume * vAx + w.risk * rAx + w.recency * recAx) /
    Math.max(1, w.volume + w.risk + w.recency);
  return Math.round(total);
};

export const tierOf = (score) =>
  score >= 70 ? "hot" : score >= 50 ? "warm" : "cold";
